import CloseableModal from "@/components/CloseableModal"
import { createBasicSelect, Form, IconButton } from "@/components/form"
import { Id, type ObjectSchemaProperty } from "@/models"
import { faArrowUpFromBracket, faPlusCircle } from "@fortawesome/free-solid-svg-icons"
import { ref, toRaw } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { getMarriageClaimProperties, getRequiredObjectSchemaProperty } from "../Helpers"
import presetData from "./ColumnPresets.json"

interface Props {
	onCancelled(): void
	onSave(columns: ObjectSchemaProperty[], replacement: boolean): void
}

interface ColumnPreset {
	Id: Id
	Name: string
	Columns: ObjectSchemaProperty[]
}

const PresetSelect = createBasicSelect<ColumnPreset>()

const ColumnManagerPresetModal: ReactiveComponent<Props> = (props) => {
	const presets: ColumnPreset[] = presetData.map((preset) => ({
		Id: preset.Id,
		Name: preset.Name,
		Columns:
			preset.Name === "All Columns"
				? getMarriageClaimProperties()
				: preset.Columns.map((column) => getRequiredObjectSchemaProperty(column)),
	}))

	const preset = ref<ColumnPreset | null>(null)
	const replacement = ref<boolean>(true)

	return () => (
		<CloseableModal title={`Column Preset Selector`} onClose={props.onCancelled} style={{ width: "36rem" }}>
			<Form onSubmit={() => props.onSave(toRaw(preset.value!.Columns), replacement.value)}>
				<PresetSelect
					options={presets}
					value={preset.value}
					setValue={(newPreset) => (preset.value = newPreset)}
					defaultText="Please select a preset"
					style="width:100%"
					required
				/>
				<IconButton
					class="mt-2"
					style="width: 100%"
					icon={faArrowUpFromBracket}
					color={"primary"}
					type="submit"
					onClick={() => (replacement.value = true)}
				>
					Replace Current Selection
				</IconButton>
				<IconButton
					class="mt-2"
					style="width: 100%"
					icon={faPlusCircle}
					color={"success"}
					type="submit"
					onClick={() => (replacement.value = false)}
				>
					Add to Current Selection
				</IconButton>
			</Form>
		</CloseableModal>
	)
}
export default defineComponent(ColumnManagerPresetModal, inferProps<Props>())
